import { CompanyBranch } from "./types/branch";

const interval = 15; // Co 15 minut
const totalMinutes = 24 * 60; // 1440 minut w 24 godzinach
export const maxPoints = totalMinutes / interval; // 96 punktów

export const weekDayLabels: any = {
  monday: "Poniedziałek",
  tuesday: "Wtorek",
  wednesday: "Środa",
  thursday: "Czwartek",
  friday: "Piątek",
  saturday: "Sobota",
  sunday: "Niedziela",
};


export const convertToTime = (value: number) => {
  const minutes = value * interval;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

export const convertTimeToNumber = (time: string): number => {
  const [hours, minutes] = time.split(":").map(Number);
  return (hours * 60 + minutes) / interval;
};

export const isBranchCurrentlyOpen = (branch?: CompanyBranch | null): boolean => {
  if (!branch || !branch.isOpen) {
    return false;
  }

  if (!branch.openingHours) {
    return true; // Domyślnie otwarte, gdy brak wprowadzonych godzin
  }

  // checking if there are ANY hours set across all days
  let hasAnyHours = false;
  const dayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  for (const day of dayNames) {
    if (branch.openingHours[day] && branch.openingHours[day].length > 0) {
      hasAnyHours = true;
      break;
    }
  }

  if (!hasAnyHours) {
    return true; // Jeżeli słownik openingHours jest pusty dla wszystkich dni, to zakładamy że są otwarte 24/7 (zgodność z domyślnym zachowaniem aplikacji)
  }

  const now = new Date();
  const currentHoursStr = String(now.getHours()).padStart(2, "0");
  const currentMinutesStr = String(now.getMinutes()).padStart(2, "0");
  const currentTimeStr = `${currentHoursStr}:${currentMinutesStr}`;

  const currentDay = dayNames[now.getDay()];
  const previousDay = dayNames[(now.getDay() - 1 + 7) % 7];

  const normalizeTimeStr = (t: string) => {
    if (!t) return t;
    const parts = t.split(":");
    if (parts.length === 2) {
      return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
    }
    return t;
  };

  const todayHours = branch.openingHours[currentDay];
  if (todayHours && todayHours.length > 0) {
    for (const range of todayHours) {
      if (!range.from || !range.till) continue;

      const from = normalizeTimeStr(range.from);
      const till = normalizeTimeStr(range.till);

      if (from <= till) {
        if (currentTimeStr >= from && currentTimeStr <= till) return true;
      } else {
        // Zmiana zachodzi za północ - jeszcze trwa dzisiaj po 'from'
        if (currentTimeStr >= from) return true;
      }
    }
  }

  const yesterdayHours = branch.openingHours[previousDay];
  if (yesterdayHours && yesterdayHours.length > 0) {
    for (const range of yesterdayHours) {
      if (!range.from || !range.till) continue;

      const from = normalizeTimeStr(range.from);
      const till = normalizeTimeStr(range.till);

      if (from > till) {
        // Zmiana z wczoraj przechodziła przez północ (czyli kończy się 'dzisiaj' do godz 'till')
        if (currentTimeStr <= till) return true;
      }
    }
  }

  return false;
};
